export function applyBranding(branding) {
  if (!branding) return;
  const root = document.documentElement;
  if (branding.primary_color) root.style.setProperty("--brand-primary", branding.primary_color);
  if (branding.secondary_color) root.style.setProperty("--brand-secondary", branding.secondary_color);
  if (branding.accent_color) root.style.setProperty("--brand-accent", branding.accent_color);
}

export function hexToHslTriplet(hex) {
  // Returns "H S% L%" suitable for HSL CSS vars (not used yet but handy).
  if (!hex || hex[0] !== "#") return null;
  let r = parseInt(hex.slice(1, 3), 16) / 255;
  let g = parseInt(hex.slice(3, 5), 16) / 255;
  let b = parseInt(hex.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}
